import cn from 'bem-cn';

export default cn('commons');